import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import Icon from './svg/checked.svg?react';

export const CheckedIcon: FC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} />;
